// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OOma","name":"styles_name__1tHc5","phone":"styles_phone__HKpkY"};